var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{staticClass:"chart-wrapper",attrs:{"type":"bar","width":"250","height":_vm.height_chart,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }